<script lang="ts">
    import dayjs from "dayjs";
    import type {StorageDocument} from "$lib/types/documents";
    import {Button, Modal} from "flowbite-svelte";

    export let item: StorageDocument;

    let open = false;

</script>

<Button on:click={() => open = true} color="light" size="xs">{dayjs.unix(item.createdAt.stamp).format('DD.MM.YYYY')}</Button>
<Modal title={item.name} bind:open>
    {#each item.versions.sort((a, b) => a.createdAt.stamp - b.createdAt.stamp) as version}
        <div class="flex gap-3 justify-between">
            <div>{dayjs.unix(version.createdAt.stamp).format('DD.MM.YYYY')}</div>
            <div><Button href={version.location} size="xs">Download</Button></div>
        </div>
    {/each}
    {#if item.versions.length === 0}
        <p>Keine vorherigen Versionen verfügbar</p>
    {/if}
</Modal>